import styled from 'styled-components';
import { mt } from 'styled-components-spacing';
import { StyledCoverMaxWidthPadding } from '@components/Wrappers';

import theme from '@theme';

const { colors } = theme;

export const StyledDocumentContainer = styled(StyledCoverMaxWidthPadding)`
  ${mt(5)}
  & > h1 {
    font-size: 32px;
    font-weight: bold;
    ${theme.typography.Raleway}
  }
  & > h3 {
    font-size: 18px;
    font-weight: bold;
    &.color {
      color: ${colors.aquaMarine};
    }
    ${theme.typography.Raleway}
  }
  & > * > b {
    font-weight: bold;
    ${theme.typography.Raleway}
  }
`;

export const StyledSitemapLink = styled.a`
  text-decoration: none;
`;
